
const UploadData = () => {
   

    return (
        <>
            
        </>
    );
};

export default UploadData;
